module.exports = __webpack_public_path__ + "static/seo-about-us-5ae2ac102396fc14addc0594eee91dad.png";